import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import AddProjectContainer from './AddProject';
import rootReducer from '../../reducers';
var store = createStore(rootReducer);
function AddProject(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(AddProjectContainer, props));
}
export default AddProject;